import { Outlet, useLocation } from 'react-router-dom';
import { RouteMeta } from '@/seo/route-meta';
import { SiteFooter } from './site-footer';
import { SiteHeader } from './site-header';

export function AppLayout() {
  const { pathname } = useLocation();
  return (
    <div className="flex min-h-dvh flex-col overflow-x-clip">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:bg-white focus:px-3 focus:py-2"
      >
        Skip to content
      </a>
      <RouteMeta />
      <SiteHeader />
      {/* Keyed on the path so each page fades up on navigation (not on query-string changes). */}
      <main id="main" key={pathname} className="page-enter flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
